import { rfTabDefinition } from 'console/tabs/legacy/rf/rf-tab';
import { maintenanceTabDefinition } from 'console/tabs/maintenance';
import { camsTabDefinition } from 'console/tabs/cams/CamsTab';
import { GTWMainTab } from 'console/tabs/legacy/state/gtw/gtw-main-tab';
import { GTWStateTab } from 'console/tabs/legacy/state/gtw/gtw-state-tab';
import ThermostatControlTab from 'console/tabs/legacy/heating/thermostat-control-tab';
import DiagTab from 'console/tabs/legacy/diag-tab/diag-tab';
import { array_uniq } from 'webui/utils/array';
import { createSubsetSelector } from 'webui/utils/selectors';
import { createSelector } from '@reduxjs/toolkit';
import { heating_tab_definition } from './heating';
import { events_tab_definition } from './events';
import { guard_tab_definition } from './guard';
import { graphs_tab_definition } from './graphs';
import { vehicle_tab_definition } from './vehicle';
import { DefaultTabKey } from 'console/shared/content/tab/types';
import { createLegacyTabDefinition } from './legacy';
import { LegacyStateTabDefinition } from './legacy/state';
import { selectSelectedDevice } from 'entities/device/lib';
import { terminal_tab_definition } from './terminal';
import { mapTabDefinition } from 'console/pages/tab.map';
import { sockets_tab_definition } from './sockets';
import { deviceKeysForZ3KCustomTabs } from './custom/type';
const gtwMainTabDef = createLegacyTabDefinition(GTWMainTab, DefaultTabKey['gtw-main'], 'Режимы', 'ui-icon-tab-temperature');
const gtwStateTabDef = createLegacyTabDefinition(GTWStateTab, DefaultTabKey['gtw-state'], 'Cостояние', 'ui-icon-tab-state');
const thermostatTabDef = createLegacyTabDefinition(ThermostatControlTab, DefaultTabKey.thermostat, 'Отопление', 'ui-icon-tab-temperature');
const diagTabDef = createLegacyTabDefinition(DiagTab, DefaultTabKey.diagnostics, 'Диагностика', 'ui-icon-tab-diagnostics');
export const staticTabDefs = [
    sockets_tab_definition,
    guard_tab_definition,
    // house_tab_definition,
    heating_tab_definition,
    thermostatTabDef,
    LegacyStateTabDefinition,
    gtwMainTabDef,
    gtwStateTabDef,
    vehicle_tab_definition,
    mapTabDefinition,
    graphs_tab_definition,
    rfTabDefinition,
    diagTabDef,
    events_tab_definition,
    maintenanceTabDefinition,
    camsTabDefinition,
    terminal_tab_definition,
];
const staticTabsDependsOn = array_uniq(staticTabDefs
    .map((newTabClass) => newTabClass.should_appear_depends_on)
    .filter((deps) => deps != null)
    .reduce((accum, deps) => [...accum, ...deps], []));
export const keys_required_by_main_content = [
    'id',
    'iconState',
    'capabilities',
    'name',
    'individual_device_name',
    'user_id',
    'access',
    'timezone',
    'device_type',
    'z3k_config',
    'camera_available',
    'is_configured_by_wizard',
    'is_configured_by_zont_wizard',
    'asp_billing',
    'online',
    'last_connect_time',
    'hardware_type',
    'thermostat_enable_guard',
    'thermostat_enabled',
    'firmware_version',
    'is_legacy_service_mode_view',
    'config_write_status',
];
export const zontTabsDeviceSelector = createSelector(selectSelectedDevice, createSubsetSelector([
    ...keys_required_by_main_content,
    ...deviceKeysForZ3KCustomTabs,
    ...staticTabsDependsOn,
]));
